import brandSellPages from './brandSellPages.json';

const getBrandSellMetaDescription = (brand) =>
  `Sell your ${brand} watch in Australia with Lux & Co. Get an instant market-based offer, secure insured handling, professional authentication, and instant payment once your quote is accepted.`;

export const BRAND_SELL_PAGES = brandSellPages.map((page) => ({
  ...page,
  metaTitle: page.metaTitle || `Sell Your ${page.brand} Watch in Australia`,
  metaDescription: page.metaDescription || getBrandSellMetaDescription(page.brand),
  heroKicker: `sell your ${page.brand.toLowerCase()} in australia`,
  heroHeading: 'secure offer',
  heroMobileKicker: 'sell your',
  heroMobileHeading: page.brand.toLowerCase()
}));

export const findBrandSellPageBySlug = (slug) =>
  BRAND_SELL_PAGES.find((page) => page.slug === slug);

export const findBrandSellPageByPath = (path) =>
  BRAND_SELL_PAGES.find((page) => page.path === path);
